import { Box } from '@qonsoll/react-design'
import styled from 'styled-components'

const MaskIconStyled = styled(Box)`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '100%'};

  background-color: ${({ color }) => color || 'transparent'};

  -webkit-mask-image: ${({ src }) => (src ? `url(${src})` : 'none')};
  mask-image: ${({ src }) => (src ? `url(${src})` : 'none')};
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
`

export default MaskIconStyled
